import { apiClient } from './api';

export const messageService = {
    async getMessages(filters = {}) {
        try {
            const response = await apiClient.get('/messages', {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('获取消息列表失败:', error);
            throw error;
        }
    },

    async getMessageById(messageId) {
        try {
            const response = await apiClient.get(`/messages/${messageId}`);
            return response.data;
        } catch (error) {
            console.error('获取消息详情失败:', error);
            throw error;
        }
    },

    async sendMessage(messageData) {
        try {
            const response = await apiClient.post('/messages', messageData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('发送消息失败:', error);
            throw error;
        }
    },

    async markAsRead(messageId) {
        try {
            const response = await apiClient.patch(`/messages/${messageId}/read`);
            return response.data;
        } catch (error) {
            console.error('标记消息为已读失败:', error);
            throw error;
        }
    },

    async deleteMessage(messageId) {
        try {
            const response = await apiClient.delete(`/messages/${messageId}`);
            return response.data;
        } catch (error) {
            console.error('删除消息失败:', error);
            throw error;
        }
    }
};

export default messageService;